import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArchive,
  faFlag,
  faTrashRestore,
  faEdit,
  faEye,
  faCopy,
  faTrashAlt,
  faTimes,
  faPlus,
  faMinus,
  faTimesCircle,
  faSpinner,
  faBell as fasBell,
  faToggleOn,
  faImages,
  faCheckCircle,
  faEnvelope,
  faUserPlus as fasUserPlus,
  faEnvelopeOpenDollar,
  faCalendarCheck,
  faDonate,
  faChartBar,
  faCommentAltDots,
  faComment,
  faCamera,
  faExclamationCircle,
  faCircle,
  faBoxOpen,
  faCloudUploadAlt,
  faEllipsisV as fasEllipsisV,
} from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import {
  faHomeAlt,
  faAnalytics,
  faUser,
  faCommentAltLines,
  faPencil,
  faUsdCircle,
  faClone,
  faCog,
  faBolt,
  faQuestionCircle,
  faInfoCircle,
  faImage,
  faBookHeart,
  faUsers,
  faMoneyCheck,
  faFileInvoice,
  faBell,
  faCode,
  faLink,
  faInbox,
  faInboxOut,
  faClipboardList,
  faFastForward,
  faUserCircle,
  faBuilding,
  faEnvelopeOpenText,
  faCreditCard,
  faMap,
  faCommentAltDollar,
  faSignOutAlt,
  faTable,
  faEllipsisV,
  faDownload,
  faChevronDown,
  faStar,
  faHeart,
  faUserPlus,
  faSlidersH,
  faFolderPlus,
  faPencilAlt,
  faPlus as farPlus,
  faClock,
  faTimesCircle as farTimesCircle,
  faArrowToRight,
  faCalendarAlt,
  faHammer,
} from '@fortawesome/pro-regular-svg-icons';

import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons';

library.add(
  faArchive,
  faTrashRestore,
  faEdit,
  faEye,
  faCopy,
  faTrashAlt,
  faTimes,
  faPlus,
  farPlus,
  faMinus,
  faTimesCircle,
  faInfoCircle,
  faHomeAlt,
  faAnalytics,
  faUser,
  faCommentAltLines,
  faPencil,
  faUsdCircle,
  faClone,
  faCog,
  faBolt,
  faQuestionCircle,
  faImage,
  faSpinner,
  faBookHeart,
  faUsers,
  faMoneyCheck,
  faFileInvoice,
  faBell,
  faCode,
  faLink,
  faInbox,
  faInboxOut,
  faClipboardList,
  faFastForward,
  faUserCircle,
  faBuilding,
  faEnvelopeOpenText,
  faCreditCard,
  faMap,
  faCommentAltDollar,
  faSignOutAlt,
  faTable,
  faEllipsisV,
  fasEllipsisV,
  faDownload,
  faChevronDown,
  fasBell,
  faStar,
  faHeart,
  faUserPlus,
  faSlidersH,
  faFolderPlus,
  faPencilAlt,
  faToggleOn,
  faImages,
  faClock,
  faEnvelope,
  fasUserPlus,
  faEnvelopeOpenDollar,
  faFacebookF,
  faTwitter,
  faCheckCircle,
  faCalendarCheck,
  faDonate,
  faCommentAltDots,
  faChartBar,
  faComment,
  faCamera,
  faExclamationCircle,
  farTimesCircle,
  faCircle,
  faBoxOpen,
  faCloudUploadAlt,
  faArrowToRight,
  faCalendarAlt,
  faHammer,
  faFlag,
);

Vue.component('font-awesome-icon', FontAwesomeIcon)

